// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.container {
  background-color: #f5f5f5;
  height: 100vh;
  position: fixed;
  width: 100vw;
}

.page-wrapper {
  display: flex;
  flex-direction: row;
}

.subContainer {
  padding: 1rem 1rem;
  width: 100%;
  padding-bottom: 4rem;
  overflow-y: scroll;
  height: 95vh;
}

::-webkit-scrollbar {
  width: 0.4vw;
  height: 0.4vw;
}

::-webkit-scrollbar-thumb {
  background: #888;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,SAAA;EACA,sBAAA;AACF;;AAEA;EACE,yBAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;AACF;;AACA;EACE,aAAA;EACA,mBAAA;AAEF;;AAAA;EACE,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;AAGF;;AAAA;EACE,YAAA;EACA,aAAA;AAGF;;AAAA;EACE,gBAAA;AAGF;;AAAA;EACE,gBAAA;AAGF","sourcesContent":["* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n.container {\n  background-color: #f5f5f5;\n  height: 100vh;\n  position: fixed;\n  width: 100vw;\n}\n.page-wrapper {\n  display: flex;\n  flex-direction: row;\n}\n.subContainer {\n  padding: 1rem 1rem;\n  width: 100%;\n  padding-bottom: 4rem;\n  overflow-y: scroll;\n  height: 95vh;\n}\n\n::-webkit-scrollbar {\n  width: 0.4vw;\n  height: 0.4vw;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #888;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
